import Header from "./components/Header";
import Main from "./pages/main";

function App() {
  return (
    <div className="container">
      <Header />
      <Main />
    </div>
  );
}

export default App;
